import React from "react";
import { ErrorMessage } from "formik";

interface ErrorMessageFieldProps {
  name: string;
  fullWidth?: boolean;
}

const ErrorMessageField = (props: ErrorMessageFieldProps) => (
  <ErrorMessage
    name={props.name}
    render={(msg) => (
      <p
        style={{
          color: "#E3345E",
          ...(props.fullWidth && { position: "absolute" }),
        }}
      >
        {msg}
      </p>
    )}
  />
);

export default ErrorMessageField;
